import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  resize: none;\n'], ['\n  width: 100%;\n  height: 100%;\n  resize: none;\n']);

import styled from 'styled-components';

export var StyledTextArea = styled.textarea(_templateObject);